export default __webpack_public_path__ + "static/media/AG01.2.4b825a13.mp3";